import React from 'react'
import PropTypes from 'prop-types'
import {Col, ControlLabel, OverlayTrigger, Popover, Row} from 'react-bootstrap'

function renderPopover(message) {
  let header  = '<div style="color: #1d0041;">Monthly Payment Breakdown</div>';

  return (
    <Popover>
      <h5 dangerouslySetInnerHTML={{__html: header}} />
      <div className="popup-container" dangerouslySetInnerHTML={{__html: message}} />
    </Popover>
  );
}

function SimpleCalculatorResult({ label, value, popover = null, helpText = null }) {
  return (
    <div className="calculator-result">
      <Row>
        <Col xs={7}>
          <ControlLabel>
            {label}
          </ControlLabel>
        </Col>
        {popover === null ? (
          <Col xs={5} className="money">
            {value}
          </Col>
        ) : (
          <OverlayTrigger trigger='click' placement='bottom' rootClose overlay={renderPopover(popover)}>
            <Col xs={5} className="money money-popover">
              {value}
            </Col>
          </OverlayTrigger>
        )}
      </Row>
      {helpText && popover && (
        <OverlayTrigger trigger='click' placement='bottom' rootClose overlay={renderPopover(popover)}>
          <Row>
            <Col xs={12} className="help-text money-popover">
              {helpText}
            </Col>
          </Row>
        </OverlayTrigger>
      )}
    </div>
  )
}

SimpleCalculatorResult.propTypes = {
  helpText: PropTypes.string,
  label: PropTypes.node,
  popover: PropTypes.string,
  value: PropTypes.node,
};

export default SimpleCalculatorResult



// WEBPACK FOOTER //
// ./src/components/SimpleCalculatorResult/index.js